import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/icons/help.svg'
import _imports_1 from '../../../public/icons/workflow/close.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-56b15f24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rhs-flyout-header" }
const _hoisted_2 = { class: "rhs-flyout-header-slot" }
const _hoisted_3 = { class: "rhs-flyout-header-content" }
const _hoisted_4 = {
  key: 0,
  class: "rhs-flyout-title"
}
const _hoisted_5 = {
  key: 1,
  class: "rhs-flyout-title"
}
const _hoisted_6 = { class: "rhs-flyout-header-actions" }
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "theme-svg",
  alt: "Help"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "theme-svg",
  alt: "Close"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "rhs-flyout-body" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Default body content", -1))
const _hoisted_15 = { class: "rhs-flyout-footer" }
const _hoisted_16 = { class: "rhs-flyout-footer-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "rhs-flyout-panel",
        style: _normalizeStyle({ height: _ctx.isEmbedded ? 'calc(100vh - 40px)' : 'calc(100vh - 86px)' })
      }, [
        _createElementVNode("header", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.title)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.title), 1))
                  : (_openBlock(), _createElementBlock("h2", _hoisted_5, "Panel"))
              ])
            ], true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "headerActions", {}, undefined, true),
            (_ctx.Can_OpenHelp)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "rhs-flyout-help-btn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openHelp && _ctx.openHelp(...args))),
                  title: _ctx.helpTooltip
                }, _hoisted_9, 8, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "rhs-flyout-close-btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args))),
              title: _ctx.closeTooltip
            }, _hoisted_12, 8, _hoisted_10)
          ])
        ]),
        _createElementVNode("main", _hoisted_13, [
          _renderSlot(_ctx.$slots, "body", {}, () => [
            _hoisted_14
          ], true)
        ]),
        _createElementVNode("footer", _hoisted_15, [
          _renderSlot(_ctx.$slots, "footer", { saveDisabled: _ctx.saveDisabled }, () => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_CommonButton, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
                type: _ctx.ButtonType.Primary,
                text: _ctx.localizer.Localize('Modal_OK')
              }, null, 8, ["type", "text"])
            ])
          ], true)
        ]),
        _renderSlot(_ctx.$slots, "modal", {}, undefined, true)
      ], 4)
    ]),
    _: 3
  }))
}